'use client'

import { useEffect, useRef } from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import {
  type AssistiveCartActionData,
  CartActionType,
  useAssistiveCartContext,
} from '@dustin-web/microsite-components/src/hooks/use-assistive-cart-context'

const AssistiveCart = () => {
  const { translate } = useTranslations()
  const assistiveCartRef = useRef<HTMLDivElement>(null)
  const { assistiveCartData } = useAssistiveCartContext()

  const getAssistiveText = (type: CartActionType, cartAction?: AssistiveCartActionData) => {
    const isNewProduct = !cartAction?.cartItems?.find(
      (item: any) => item.productErpIdentifier == cartAction.product?.productErpIdentifier
    )

    switch (type) {
      case CartActionType.SINGLEPRODUCT:
        if (cartAction!.product!.newQuantity === 0) {
          return `${cartAction!.product!.displayName} ${translate('Cart_Removed_From_Cart')}`
        } else if (isNewProduct) {
          return `${cartAction!.product!.newQuantity} ${
            cartAction!.product!.displayName
          } ${translate('Added_To_Cart')}`
        } else {
          return `${translate('Cart_Quantity_Changed', {
            productName: cartAction!.product!.displayName,
          })} ${cartAction!.product!.newQuantity}`
        }
      case CartActionType.MULTIPLEPRODUCTS:
        return `${cartAction!.numberOfProducts} ${translate('Cart_Products')} ${translate(
          'Added_To_Cart'
        )}`.toLocaleLowerCase()

      case CartActionType.CLEARCART:
        return translate('Cart_Header_EmptyCart')
    }
    return ''
  }

  useEffect(() => {
    if (!assistiveCartData) return

    const { type, actionData } = assistiveCartData

    const ariaLabelText = getAssistiveText(type, actionData)
    assistiveCartRef.current?.setAttribute('aria-label', ariaLabelText)
  }, [assistiveCartData])

  return <div ref={assistiveCartRef} aria-live="polite" className="u-pr-0" />
}

export default AssistiveCart
